module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_aquarium-739dfd8a2dbb5e4835022503c169996e.jpg";